import { toString, FSharpRef, Record, Union } from "../fable_modules/fable-library.3.7.1/Types.js";
import { int32_type, record_type, string_type, class_type, union_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { MakeData_subMake, Types_PersonSub$reflection } from "../MakeData.fs.js";
import { createElement } from "react";
import { round, int32ToString, equals, createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Table_toggleAllRowsSelected_Z4395D14A, Row_toggleSelected_773C3262, Row_getIsSomeSelected_773C3262, Row_getIsSelected_773C3262, Table_getIsAllRowsSelected_Z4395D14A, Table_getIsSomeRowsSelected_Z4395D14A } from "../../Feliz.TanStack.Table/Selection.fs.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { Table_toggleAllRowsExpanded_Z4395D14A, Row_toggleExpanded_773C3262, Table_getIsAllRowsExpanded_Z4395D14A } from "../../Feliz.TanStack.Table/Expanding.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { map, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { Row_getValue, Row_getIsExpanded_773C3262, Row_getCanExpand_773C3262 } from "../../Feliz.TanStack.Table/Row.fs.js";
import { columnDef_id_Z721C83C5, columnDef_accessorFn_77A7E8C8, columnDef_cell_Z1DDB00E5, columnDef_header_Z5FD1F5D2, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_footer_Z5FD1F5D2, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getPreFilteredRowModel_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_39247646, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_expandedRowModel, tableProps_paginationRowModel, tableProps_filteredRowModel, tableProps_getSubRows_7C4B0DD6, tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_hasNextPage_Z4395D14A, Table_hasPreviousPage_Z4395D14A, Table_setPageSize, Table_getPageCount_Z4395D14A, Table_setPageIndex, Table_nextPage_Z4395D14A, Table_previousPage_Z4395D14A } from "../../Feliz.TanStack.Table/Pagination.fs.js";
import { Column_getFilterValue_Z2685F962, Column_getCanFilter_Z2685F962, Column_setFilterValue } from "../../Feliz.TanStack.Table/Filter.fs.js";
import { tryParse } from "../fable_modules/fable-library.3.7.1/Int32.js";
import { some, value as value_83 } from "../fable_modules/fable-library.3.7.1/Option.js";
import { FSharpMap__get_Item, ofList } from "../fable_modules/fable-library.3.7.1/Map.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.1/Range.js";
import { Table_getState_Z4395D14A } from "../../Feliz.TanStack.Table/TableState.fs.js";
import { head } from "../fable_modules/fable-library.3.7.1/Array.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class FilterChangeType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Min", "Max", "Search"];
    }
}

export function FilterChangeType$reflection() {
    return union_type("Examples.Expanding.FilterChangeType", [], FilterChangeType, () => [[], [], []]);
}

export class FilterChange extends Record {
    constructor(Column, Type, Value) {
        super();
        this.Column = Column;
        this.Type = Type;
        this.Value = Value;
    }
}

export function FilterChange$reflection() {
    return record_type("Examples.Expanding.FilterChange", [], FilterChange, () => [["Column", class_type("Feliz.TanStack.Table.Types.Column`1", [Types_PersonSub$reflection()])], ["Type", FilterChangeType$reflection()], ["Value", string_type]]);
}

export class PaginateChange extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["First", "Previous", "Next", "Last", "Index"];
    }
}

export function PaginateChange$reflection() {
    return union_type("Examples.Expanding.PaginateChange", [], PaginateChange, () => [[], [], [], [], [["Item", int32_type]]]);
}

export class State extends Record {
    constructor(Table) {
        super();
        this.Table = Table;
    }
}

export function State$reflection() {
    return record_type("Examples.Expanding.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Types_PersonSub$reflection()])]]);
}

export class Expand extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["All", "Row"];
    }
}

export function Expand$reflection() {
    return union_type("Examples.Expanding.Expand", [], Expand, () => [[], [["Item", class_type("Feliz.TanStack.Table.Types.Row`1", [Types_PersonSub$reflection()])]]]);
}

export class Select extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["All", "Row"];
    }
}

export function Select$reflection() {
    return union_type("Examples.Expanding.Select", [], Select, () => [[], [["Item", class_type("Feliz.TanStack.Table.Types.Row`1", [Types_PersonSub$reflection()])]]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FilterChanged", "Paginate", "PageSizeChange", "ExpandClicked", "SelectClicked"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Expanding.Msg", [], Msg, () => [[["Item", FilterChange$reflection()]], [["Item", PaginateChange$reflection()]], [["Item", int32_type]], [["Item", Expand$reflection()]], [["Item", Select$reflection()]]]);
}

export function firstNameHeader(props) {
    let elems_1, elems;
    return createElement("span", createObj(singleton((elems_1 = [createElement("input", {
        type: "checkbox",
        ref: (e) => {
            if (equals(e, null)) {
            }
            else {
                e.indeterminate = Table_getIsSomeRowsSelected_Z4395D14A(props.table);
            }
        },
        checked: Table_getIsAllRowsSelected_Z4395D14A(props.table),
        onChange: (_arg1) => {
            props.dispatch(new Msg(4, new Select(0)));
        },
    }), createElement("button", createObj(ofArray([["className", join(" ", ["ghost-button"])], ["onClick", (_arg2) => {
        props.dispatch(new Msg(3, new Expand(0)));
    }], (elems = [Table_getIsAllRowsExpanded_Z4395D14A(props.table) ? "👇" : "👉", "First Name"], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]))));
}

export function firstNameCell(props) {
    let properties, elems_1;
    return createElement("span", createObj(ofArray([(properties = singleton(["paddingLeft", (props.row.depth * 0.5) + "rem"]), ["style", createObj(properties)]), (elems_1 = toList(delay(() => append(singleton_1(createElement("input", {
        type: "checkbox",
        checked: Row_getIsSelected_773C3262(props.row),
        ref: (e) => {
            if (equals(e, null)) {
            }
            else {
                e.indeterminate = Row_getIsSomeSelected_773C3262(props.row);
            }
        },
        onChange: (_arg1) => {
            const arg00 = new Msg(4, new Select(1, props.row));
            props.dispatch(arg00);
        },
    })), delay(() => {
        let elems, children;
        return Row_getCanExpand_773C3262(props.row) ? singleton_1(createElement("button", createObj(ofArray([["className", join(" ", ["ghost-button"])], ["onClick", (_arg2) => {
            const arg00_1 = new Msg(3, new Expand(1, props.row));
            props.dispatch(arg00_1);
        }], (elems = [Row_getIsExpanded_773C3262(props.row) ? "👇" : "👉", props.getValue()], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1((children = ofArray(["🔵", props.getValue()]), createElement("span", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        })));
    })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_footer_Z5FD1F5D2((props) => props.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_header_Z5FD1F5D2(firstNameHeader), columnDef_cell_Z1DDB00E5(firstNameCell), columnDef_footer_Z5FD1F5D2((props_3) => props_3.column.id)]), ofArray([columnDef_accessorFn_77A7E8C8((p) => p.Lastname), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("p", {
    children: ["Hi"],
})), columnDef_footer_Z5FD1F5D2((props_5) => props_5.column.id)])]))]), ofArray([columnDef_header_Z721C83C5("Info"), columnDef_footer_Z5FD1F5D2((props_6) => props_6.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((props_7) => props_7.column.id)]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((props_9) => props_9.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((props_10) => props_10.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((props_11) => props_11.column.id)])]))])]))])]);

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", MakeData_subMake(100, ofArray([10, 10]))], tableProps_columns_Z2906D979(defaultColumns), tableProps_getSubRows_7C4B0DD6((p) => p.SubRows), tableProps_filteredRowModel(), tableProps_paginationRowModel(), tableProps_expandedRowModel(), ["autoResetPageIndex", true]]))), Cmd_none()];
}

export function update(msg, state) {
    let outArg;
    if (msg.tag === 1) {
        return [new State((msg.fields[0].tag === 1) ? Table_previousPage_Z4395D14A(state.Table) : ((msg.fields[0].tag === 2) ? Table_nextPage_Z4395D14A(state.Table) : ((msg.fields[0].tag === 3) ? Table_setPageIndex(Table_getPageCount_Z4395D14A(state.Table) - 1, state.Table) : ((msg.fields[0].tag === 4) ? Table_setPageIndex(msg.fields[0].fields[0] - 1, state.Table) : Table_setPageIndex(0, state.Table))))), Cmd_none()];
    }
    else if (msg.tag === 2) {
        return [new State(Table_setPageSize(msg.fields[0], state.Table)), Cmd_none()];
    }
    else if (msg.tag === 3) {
        if (msg.fields[0].tag === 1) {
            Row_toggleExpanded_773C3262(msg.fields[0].fields[0]);
            return [new State(state.Table), Cmd_none()];
        }
        else {
            return [new State(Table_toggleAllRowsExpanded_Z4395D14A(state.Table)), Cmd_none()];
        }
    }
    else if (msg.tag === 4) {
        if (msg.fields[0].tag === 1) {
            Row_toggleSelected_773C3262(msg.fields[0].fields[0]);
            return [new State(state.Table), Cmd_none()];
        }
        else {
            return [new State(Table_toggleAllRowsSelected_Z4395D14A(state.Table)), Cmd_none()];
        }
    }
    else {
        const matchValue = msg.fields[0].Type;
        if (matchValue.tag === 2) {
            Column_setFilterValue((_arg1) => msg.fields[0].Value, msg.fields[0].Column);
        }
        else {
            const matchValue_1 = [(outArg = 0, [tryParse(msg.fields[0].Value, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg]), matchValue];
            let pattern_matching_result;
            if (matchValue_1[0][0]) {
                if (matchValue_1[1].tag === 1) {
                    pattern_matching_result = 0;
                }
                else if (matchValue_1[1].tag === 0) {
                    pattern_matching_result = 1;
                }
                else {
                    pattern_matching_result = 2;
                }
            }
            else {
                pattern_matching_result = 2;
            }
            switch (pattern_matching_result) {
                case 0: {
                    const n = matchValue_1[0][1] | 0;
                    Column_setFilterValue((prevOpt) => {
                        let min;
                        return (prevOpt != null) ? ((prevOpt[0] != null) ? ((min = value_83(prevOpt[0]), [some(min), n])) : [void 0, n]) : [void 0, n];
                    }, msg.fields[0].Column);
                    break;
                }
                case 1: {
                    const n_1 = matchValue_1[0][1] | 0;
                    Column_setFilterValue((prevOpt_1) => {
                        let max;
                        return (prevOpt_1 != null) ? ((prevOpt_1[1] != null) ? ((max = value_83(prevOpt_1[1]), [n_1, some(max)])) : [n_1, void 0]) : [n_1, void 0];
                    }, msg.fields[0].Column);
                    break;
                }
            }
        }
        return [new State(state.Table), Cmd_none()];
    }
}

export function view(state, dispatch) {
    let elems_3, children, properties_8, elems_2, elems_1, elems_8;
    let paginationControls;
    const selectOptions = ofList(toList(delay(() => map((i) => [int32ToString(i), [`Show ${i}`, () => {
        dispatch(new Msg(2, i));
    }]], rangeDouble(10, 10, 50)))));
    const pageControl = (text, isDisabled, onClick) => createElement("button", {
        className: join(" ", ["button"]),
        children: text,
        disabled: isDisabled,
        onClick: onClick,
    });
    paginationControls = createElement("div", createObj(ofArray([["className", join(" ", ["is-inline-block"])], (elems_3 = [pageControl("\u003c\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg2) => {
        dispatch(new Msg(1, new PaginateChange(0)));
    }), pageControl("\u003c", !Table_hasPreviousPage_Z4395D14A(state.Table), (_arg3) => {
        dispatch(new Msg(1, new PaginateChange(1)));
    }), pageControl("\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg4) => {
        dispatch(new Msg(1, new PaginateChange(2)));
    }), pageControl("\u003e\u003e", !Table_hasNextPage_Z4395D14A(state.Table), (_arg5) => {
        dispatch(new Msg(1, new PaginateChange(3)));
    }), (children = ofArray(["Page ", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1, " of ", Table_getPageCount_Z4395D14A(state.Table), " | Go to page:"]), createElement("p", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), createElement("input", createObj(ofArray([["className", join(" ", ["input"])], ["type", "number"], (properties_8 = singleton(["width", 4 + "rem"]), ["style", createObj(properties_8)]), ["defaultValue", Table_getState_Z4395D14A(state.Table).pagination.pageIndex + 1], ["onChange", (ev_3) => {
        const value_54 = ev_3.target.valueAsNumber;
        if ((!(value_54 == null)) && (!Number.isNaN(value_54))) {
            dispatch(new Msg(1, new PaginateChange(4, round(value_54))));
        }
    }]]))), createElement("div", createObj(ofArray([["className", join(" ", ["select"])], (elems_2 = [createElement("select", createObj(ofArray([["onChange", (event) => {
        FSharpMap__get_Item(selectOptions, event.target.value)[1]();
    }], ["value", `${Table_getState_Z4395D14A(state.Table).pagination.pageSize}`], (elems_1 = toList(delay(() => map((option) => createElement("option", {
        key: option[0],
        value: option[0],
        children: option[1][0],
    }), selectOptions))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
    let table_1;
    let thead;
    const children_4 = toList(delay(() => map((headerGroup) => {
        let elems_5;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_5 = toList(delay(() => map((header) => {
            let elems_4;
            return createElement("th", createObj(ofArray([["key", header.id], ["colSpan", header.colSpan], (elems_4 = toList(delay(() => {
                let children_2;
                return header.isPlaceholder ? singleton_1(null) : singleton_1((children_2 = toList(delay(() => append(singleton_1(Html_flexRender_39247646(state, dispatch, header.column.columnDef.header, Table_getContext_315F98D7(header))), delay(() => {
                    let column, firstValue, columnFilterValue, elems;
                    return Column_getCanFilter_Z2685F962(header.column) ? singleton_1((column = header.column, (firstValue = Row_getValue(column, head(Table_getPreFilteredRowModel_Z4395D14A(state.Table).flatRows)), (columnFilterValue = Column_getFilterValue_Z2685F962(column), createElement("div", createObj(ofArray([["className", join(" ", ["is-flex"])], (elems = toList(delay(() => {
                        let properties, v, properties_4;
                        return (typeof firstValue === 'number') ? append(singleton_1(createElement("input", createObj(ofArray([(properties = singleton(["width", 6 + "rem"]), ["style", createObj(properties)]), ["placeholder", "Min..."], ["value", (columnFilterValue != null) ? ((columnFilterValue[0] != null) ? ((v = columnFilterValue[0], v[0])) : "") : ""], ["onChange", (ev) => {
                            dispatch(new Msg(0, new FilterChange(column, new FilterChangeType(0), ev.target.value)));
                        }]])))), delay(() => {
                            let properties_2, v_1;
                            return singleton_1(createElement("input", createObj(ofArray([(properties_2 = singleton(["width", 6 + "rem"]), ["style", createObj(properties_2)]), ["placeholder", "Max..."], ["value", (columnFilterValue != null) ? ((columnFilterValue[1] != null) ? ((v_1 = columnFilterValue[1], v_1[1])) : "") : ""], ["onChange", (ev_1) => {
                                dispatch(new Msg(0, new FilterChange(column, new FilterChangeType(1), ev_1.target.value)));
                            }]]))));
                        })) : singleton_1(createElement("input", createObj(ofArray([(properties_4 = singleton(["width", 8 + "rem"]), ["style", createObj(properties_4)]), ["placeholder", "Search..."], ["value", (columnFilterValue == null) ? "" : toString(columnFilterValue)], ["onChange", (ev_2) => {
                            dispatch(new Msg(0, new FilterChange(column, new FilterChangeType(2), ev_2.target.value)));
                        }]]))));
                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))))))) : singleton_1(null);
                })))), createElement("div", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_2)),
                })));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tbody;
    const children_8 = toList(delay(() => map((row) => {
        let elems_6;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_6 = toList(delay(() => map((cell) => {
            const children_6 = singleton(Html_flexRender_39247646(state, dispatch, cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_6)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_8)),
    });
    table_1 = createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_8 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody]),
    }), paginationControls], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])));
    return createElement("div", {
        children: Interop_reactApi.Children.toArray([table_1]),
    });
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Expanding.fs.js.map
